<script lang="ts">
  import { toPersianDigits } from '@clinic/money-date';
  import { fieldErrors } from '../../../shared/api/errors';
  import { useOrg } from '../../../shared/auth/org.svelte';
  import { fa } from '../../../shared/i18n/fa';
  import { online } from '../../../shared/lib/online.svelte';
  import { Alert, Button, Card, ErrorAlert, Field, Input } from '../../../shared/ui';
  import { useUpdateInventorySettings } from '../api/inventory-api';

  let { initial }: { initial: { expiryAlertDays: number; expiryWarnDays: number } } = $props();

  const org = useOrg();
  const update = useUpdateInventorySettings(org.orgId);
  // The form starts from the saved thresholds; a change remounts it.
  // svelte-ignore state_referenced_locally
  let alertDays = $state(toPersianDigits(initial.expiryAlertDays));
  // svelte-ignore state_referenced_locally
  let warnDays = $state(toPersianDigits(initial.expiryWarnDays));
  let saved = $state(false);
  const server = $derived(fieldErrors(update.error));
  const toNumber = (v: string) => Number.parseInt(v.replace(/[۰-۹]/g, (d) => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(d))), 10);

  function submit(e: SubmitEvent) {
    e.preventDefault();
    saved = false;
    update.mutate({ expiryAlertDays: toNumber(alertDays), expiryWarnDays: toNumber(warnDays) }, { onSuccess: () => (saved = true) });
  }
</script>

<Card class="max-w-xl">
  <form onsubmit={submit} novalidate class="flex flex-col gap-4">
    <div>
      <h2 class="font-bold">{fa.inventory.settings.title}</h2>
      <p class="text-sm text-text-3">{fa.inventory.settings.hint}</p>
    </div>
    <Field label={fa.inventory.settings.alertDays} error={server.expiryAlertDays}>
      {#snippet children(a11y)}
        <Input {...a11y} bind:value={alertDays} inputmode="numeric" dir="ltr" />
      {/snippet}
    </Field>
    <Field label={fa.inventory.settings.warnDays} error={server.expiryWarnDays}>
      {#snippet children(a11y)}
        <Input {...a11y} bind:value={warnDays} inputmode="numeric" dir="ltr" />
      {/snippet}
    </Field>
    <div aria-live="polite" class="empty:hidden">
      {#if saved}<Alert tone="success">{fa.inventory.settings.saved}</Alert>{/if}
    </div>
    {#if update.error && Object.keys(server).length === 0}<ErrorAlert error={update.error} />{/if}
    <Button type="submit" class="self-start" loading={update.isPending} done={update.isSuccess} disabled={!online.value}>{fa.app.save}</Button>
  </form>
</Card>
